import { IPhoto, IAttachment } from '../../../models/Checklist'

export function getPhotos(photos: IPhoto[] | null): IPhoto[] {
  return photos
    ? photos.filter((p) => !p.attachmentType || p.attachmentType === 'photo')
    : []
}

export function isVideoAttachment(photo: IPhoto): boolean {
  return photo.attachmentType === 'video'
}

export function getVideos(photos: IPhoto[] | null): IPhoto[] {
  return photos ? photos.filter((p) => isVideoAttachment(p)) : []
}

export function getNonVideoAttachments(photos: IPhoto[] | null): IPhoto[] {
  return photos
    ? photos.filter((p) => p.attachmentType === 'attachment')
    : []
}

export function hasPhotos(photos: IPhoto[] | null): boolean {
  return getPhotos(photos).length > 0
}

export function hasAttachments(photos: IPhoto[] | null): boolean {
  return getNonVideoAttachments(photos).length > 0
}

export function hasVideos(photos: IPhoto[] | null): boolean {
  return getVideos(photos).length > 0
}

export function createPhotoAttachment(attachment: IAttachment): IPhoto {
  const photo = {} as IPhoto
  photo.id = attachment.id
  photo.fileName = attachment.fileName
  photo.uuid = attachment.uuid
  photo.url = attachment.url || attachment.localObjectUrl || ''
  photo.localObjectUrl = attachment.url
    ? undefined
    : attachment.localObjectUrl || undefined
  photo.attachmentType = attachment.attachmentType ?? 'attachment'
  photo.contentType = attachment.contentType
  photo.fileSize = attachment.fileSize
  photo.comment = attachment.comment || ''
  photo.file = attachment.file
  return photo
}

export function createAttachment(photo: IPhoto): IAttachment {
  return {
    id: photo.id,
    comment: photo.comment,
    fileName: photo.fileName,
    uuid: photo.uuid,
    url: photo.url,
    localObjectUrl: photo.localObjectUrl,
    contentType: photo.contentType,
    fileSize: photo.fileSize
  } as IAttachment
}

export function createAttachments(photos: IPhoto[]): IAttachment[] {
  return photos.map((photo) => createAttachment(photo))
}

export function isAttachment(
  attachment: IAttachment | IPhoto
): attachment is IAttachment {
  return (<IPhoto>attachment).thumbnailUrl === undefined
}

export function convertVideosToAttachments(photos: IPhoto[]): IAttachment[] {
  return photos.map((photo) => ({
    url: null,
    id: null,
    localObjectUrl: photo.localObjectUrl || null,
    file: photo.file || null,
    fileName: photo.fileName,
    fileSize: photo.fileSize,
    contentType: photo.contentType,
    status: null,
    uuid: null,
    fileSizeExceeded: false,
    attachmentType: 'video'
  } as IAttachment))
}
